import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  categorySlug: string;
  categoryName: string;
  excerpt: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  coverUrl: string;
  tags: string[];
  featured?: boolean;
}

export default function ArticleCard({
  id,
  title,
  categoryName,
  excerpt,
  author,
  authorAvatar,
  publishDate,
  readTime,
  coverUrl,
  featured,
}: ArticleCardProps) {
  if (featured) {
    return (
      <Link
        to={`/article/${id}`}
        className="group block bg-background-50 rounded-xl overflow-hidden hover:scale-[1.01] transition-transform duration-300"
      >
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-[480px] h-64 lg:h-72 overflow-hidden flex-shrink-0">
            <img
              src={coverUrl}
              alt={title}
              title={`${title} - 水蜜桃视频`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="p-6 md:p-7 flex flex-col justify-center flex-1">
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3 w-fit whitespace-nowrap">
              {categoryName}
            </span>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
              {title}
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2">
              {excerpt}
            </p>
            <div className="flex items-center gap-4">
              <img
                src={authorAvatar}
                alt={author}
                className="w-8 h-8 rounded-full object-cover"
              />
              <span className="text-sm text-foreground-500">{author}</span>
              <span className="text-foreground-400 text-xs">&middot;</span>
              <span className="text-sm text-foreground-500">{publishDate}</span>
              <span className="text-foreground-400 text-xs">&middot;</span>
              <span className="text-sm text-foreground-500">{readTime}</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform duration-300"
    >
      <div className="h-48 overflow-hidden">
        <img
          src={coverUrl}
          alt={title}
          title={`${title} - 水蜜桃视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
            {categoryName}
          </span>
          <span className="text-foreground-400 text-xs">{publishDate}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-foreground-600 text-sm leading-relaxed mb-3 line-clamp-2">
          {excerpt}
        </p>
        <div className="flex items-center gap-2">
          <img
            src={authorAvatar}
            alt={author}
            className="w-6 h-6 rounded-full object-cover"
          />
          <span className="text-xs text-foreground-500">{author}</span>
          <span className="text-foreground-400 text-xs">&middot;</span>
          <span className="text-xs text-foreground-500">{readTime}</span>
        </div>
      </div>
    </Link>
  );
}